var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4692 4.0993L18.3854 17.9316C18.653 18.467 18.436 19.1179 17.9007 19.3856C17.7502 19.4608 17.5843 19.5 17.4161 19.5H3.58371C2.98519 19.5 2.5 19.0148 2.5 18.4163C2.5 18.2481 2.53917 18.0821 2.61441 17.9316L9.53059 4.0993C9.79825 3.56397 10.4492 3.34698 10.9845 3.61465C11.1943 3.71951 11.3643 3.88957 11.4692 4.0993Z",
    fill: "#FF6B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8996 11.0953C10.8996 10.8744 10.7205 10.6953 10.4996 10.6953C10.2787 10.6953 10.0996 10.8744 10.0996 11.0953V13.8953C10.0996 14.1162 10.2787 14.2953 10.4996 14.2953C10.7205 14.2953 10.8996 14.1162 10.8996 13.8953V11.0953ZM10.8996 15.0953C10.8996 14.8744 10.7205 14.6953 10.4996 14.6953C10.2787 14.6953 10.0996 14.8744 10.0996 15.0953C10.0996 15.3162 10.2787 15.4953 10.4996 15.4953C10.7205 15.4953 10.8996 15.3162 10.8996 15.0953Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.495054f3.svg";
export { ForwardRef as ReactComponent };